export default "__VITE_ASSET__sPGWgz1m__"